//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { Serialized } from '@utils/types/Serialized';

type Deserializer<T> = (x: Serialized<T>) => T;

export interface ISerializedResponse extends Omit<Response, 'json'> {
  /**
   * Get the JSON-deserialized payload from a response body.
   * @param deserializer Function to deserialize the API data. Required when the Serialized type differs.
   */
  json: <T>(
    ...deserializer: T extends Serialized<T> ? [] : [Deserializer<T>]
  ) => Promise<T>;
}

export function makeSerializedResponse(res: Response): ISerializedResponse {
  const originalJson = res.json;

  res.json = async <T>(
    // If T and Serialized<T> are the same, don't require a deserializeFn.
    ...deserializer: T extends Serialized<T> ? [] : [Deserializer<T>]
  ): Promise<T> => {
    const data: Serialized<T> = await originalJson.call(res);
    const deserializeFn = deserializer[0];
    if (deserializeFn) {
      return deserializeFn(data);
    }
    return data as T;
  };

  return res;
}
